import { render, staticRenderFns } from "./ConnectWithOtherDoctorTemplate.vue?vue&type=template&id=5f3fdf34"
import script from "./ConnectWithOtherDoctorTemplate.vue?vue&type=script&lang=js"
export * from "./ConnectWithOtherDoctorTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports